import React, { useEffect } from 'react';
import { useUpdater } from './UpdaterProvider';

const ReceiptNormalComponent = ({
  selectedDate,
  sysInfo,
  clientInfo,
  generalsettings,
  receiptData,
  username
}) => {
  const productsPerPage = 6; 

  if (!receiptData) {
    return null;
  }

//   const validProducts = products.filter(product => product.id && product.name);

//   const totalPages = Math.ceil(validProducts.length / productsPerPage);

//   useEffect(() => {
//     setTotalPages(totalPages);
//   }, [products]);

//   const paginatedProducts = products.slice((currentPage - 1) * productsPerPage, currentPage * productsPerPage);
//   const { checkForUpdates, currentVersion } = useUpdater();
    
  const formatCurrency = (amount) => {
    return amount.toFixed(2);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const formatTime = () => {
    return new Date().toLocaleTimeString('en-IN', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  return (
    <div className="flex h-screen bg-background">
        <div className="p-8 bg-gray-500">
            <div
                id="receiptDiv"
                style={{ page: "A5" }}
                className="h-[559px] w-[793px] bg-white flex flex-col justify-between"
            >
                <div className="p-2 flex-grow">
                    <div className="flex justify-between">
                        <div className="flex flex-col">
                            <p className="text-lg font-bold">{generalsettings?.FirstName}</p>
                            <p className="text-sm">{generalsettings?.LastName}</p>
                            <p className="text-sm">{generalsettings?.MobileNo1} , {generalsettings?.MobileNo2}</p>
                        </div>

                        <div className="border-l-4 border-black p-1">
                            <p className="text-sm">{generalsettings?.AddressLine1}</p>
                            <p className="text-sm">{generalsettings?.AddressLine2}</p>
                            <p className="text-sm">{generalsettings?.Place}</p>
                            <p className="text-sm">Working Time: {generalsettings?.WorkingTime}</p>
                        </div>
                    </div>

                    <p className="text-center text-black text-lg font-bold">PAYMENT RECEIPT</p>

                    <div className="flex mt-1 bg-white">
                        <div className="w-full">
                            <div className="flex justify-between w-full">
                                <div className="flex flex-row gap-5 items-center w-full justify-start">
                                    <p className="text-sm">Receipt No:</p>
                                    <p className="text-black font-semibold">
                                        {receiptData?.receiptNumber || 0}
                                    </p>
                                </div>
                                <div className='w-full text-right'>
                                    <p className="text-black text-xs font-semibold">Date: {formatDate(selectedDate)}</p>
                                </div>
                            </div>

                            <div className="flex flex-col gap-1 mt-2">
                                <div className="flex justify-between">
                                    <div className="flex flex-row gap-5 w-full justify-start items-center">
                                        <p className="text-sm">Name :</p>
                                        {!receiptData.isMultiplePatients && (
                                            <p className="text-black text-sm">
                                                {receiptData.patients[0]?.patientName}
                                            </p>
                                        )}

                                        {receiptData.isMultiplePatients && (
                                            <p className="text-black text-sm">
                                                MULTIPLE PATIENTS ({receiptData.patients.length})
                                            </p>
                                        )}
                                    </div>
                                    <div className='w-full text-right'>
                                        <p className="text-black text-xs font-semibold">Time: {formatTime()}</p>
                                    </div>
                                </div>
                            </div>

                            <div className="flex flex-col gap-1 mt-2">
                                <div className="flex flex-row gap-5 items-center w-full justify-start">
                                    <p className="text-sm">PPayment Mode:</p>
                                    <p className="text-black font-semibold">
                                        {receiptData.paymentMethod}
                                    </p>
                                </div>
                            </div>

                            <div className="mt-2">
                                <div className="flex justify-between mb-1 w-full">
                                    <p className="text-black font-semibold text-sm w-full text-left" style={{ width: '65%' }}>Department</p>
                                    <p className="text-black font-semibold text-sm w-full text-right" style={{ width: '10%' }}>Amount</p>
                                </div>
                                <div className="w-full h-0.5 bg-black"></div>

                                <div className="flex flex-col gap-2 mt-1 flex-grow w-full">
                                    {receiptData.departmentTotals.map((dept, index) => (
                                        <div key={index} className="mb-1">
                                            <div className="flex justify-between text-xs">
                                            <span className="font-bold flex-1" style={{ maxWidth: '70%', wordBreak: 'break-word' }}>
                                                {dept.departmentName} ({dept.billCount} Bills)
                                            </span>
                                            <span className="font-bold text-right whitespace-nowrap">₹{formatCurrency(dept.totalPaying)}</span>
                                            </div>
                                            
                                            {/* Show invoice numbers for this department */}
                                            <div className="ml-2 text-xs">
                                            {dept.bills.map((bill, billIndex) => (
                                                <div key={billIndex} className="flex justify-between">
                                                <span className='font-bold' style={{ maxWidth: '65%', wordBreak: 'break-word' }}>
                                                    Inv-{bill.invoiceNo}
                                                </span>
                                                <span className="font-bold text-right">₹{formatCurrency(bill.payingAmount)}</span>
                                                </div>
                                            ))}
                                            </div>
                                            
                                            {/* Show remaining amount if any */}
                                            {dept.totalRemaining > 0 && (
                                            <div className="ml-2 text-xs text-gray-600">
                                                <div className="flex justify-between">
                                                <span>Remaining Balance:</span>
                                                <span>₹{formatCurrency(dept.totalRemaining)}</span>
                                                </div>
                                            </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer Section with Line and Amounts */}
                <div className="w-full">
                    {/* Line above the amounts */}
                    <div className="w-full h-0.5 bg-black mb-1"></div>

                    {/* Amounts Section */}
                
                    <div className="flex flex-row gap-10 p-2 justify-between items-start">
                        {/* Printed By Line */}
                        <div className="flex flex-col justify-between w-full">
                            <p className="text-xs self-start mb-1">
                                Printed By User: {username || sysInfo?.userName}
                            </p>
                        </div>


                        <div className="flex flex-col gap-0.5 text-right w-full">
                            <p className="text-sm font-semibold text-black">Total Bills</p>
                            <p className="text-sm font-semibold text-black">Total Amount</p>
                            <p className="text-sm font-semibold text-black">Amount Paid</p>
                            <p className="text-sm font-semibold text-black">Amount Due</p>
                        </div>
                        <div className="flex flex-col gap-0.5 text-right">
                            <p className="text-sm font-semibold text-black">
                                {receiptData.billCount}
                            </p>
                            <p className="text-sm font-semibold text-black">
                                ₹{formatCurrency(receiptData.totalDueAmount)}
                            </p>
                            <p className="text-sm font-semibold text-black">
                                ₹{formatCurrency(receiptData.totalPayingAmount)}
                            </p>
                            <p className="text-sm font-semibold text-black">
                                ₹{formatCurrency(receiptData.totalRemainingAmount)}
                            </p>
                        </div>
                    </div>

                    {/* Line at the bottom */}
                    <div className="w-full h-0.5 bg-black"></div>
                    <div className="w-full flex justify-center items-center pb-1">
                        <p className="text-sm">
                            Thank You for Your Payment!
                        </p>
                    </div>
                    <div className="text-xs mb-1 font-bold">
                        Printed By User: {username || sysInfo?.userName}
                    </div>
                </div>
            </div>
        </div>
    </div>


  );
};

export default ReceiptNormalComponent;
